import { canEdit, deleteObject } from '../data';
import { ErnotsAbstractModel } from '../models';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { RequestStatusDisplay } from '../../features/CommonComponents';
import { Anchor } from "../../features/RequestRespectingInputs";
import { Button } from "../../features/RequestRespectingInputs";
import { useState } from 'react';
import { RequestStatus } from '../../api_request/api_request';

/**
 * A reusable component that shows a button to delete an object from the database.
 * Shows the status of the delete request next to the button.
 * 
 * Props:
 *     object - An instance of ErnotsAbstractModel that must be deleted (converted to a plain object.)
 *     messageOnNewLine - If true, the status messages are displayed in a 
 */
export function DeleteRestObjectButton(props: Props)
{
    const appDispatch = useAppDispatch();
    const [request, setRequest] = useState<RequestStatus|undefined>(undefined);

    const obj = props.object;    
    const loginState = useAppSelector((state) => state.login);

    //If current user doesn't own this object, don't try to delete it.
    if (!canEdit(obj, loginState))
    {
        return <></>;
    }

    function onClick(e: React.SyntheticEvent)
    {
        e.preventDefault();
        if (window.confirm('Delete this item?'))
        {
            deleteObject(obj, appDispatch, setRequest);
        }
    }
    
    const clickable = props.link
        ? <Anchor to='' onClick={onClick}>Delete</Anchor>
        : <Button onClick={onClick}>Delete</Button>
    
    return (
    <>
        {clickable}
        <RequestStatusDisplay
            request={request}
            style={{display: props.messageOnNewLine ? 'block' : undefined}}/>
    </>);
}

interface Props
{
    object: ErnotsAbstractModel;
    messageOnNewLine: boolean;
    link?: boolean;
}